/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
import SamskritiOfferingCard from '@components/Card/SamskritiOfferingCard';
import SectionUI from '@components/UI/Common/SectionUI';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Services  */
/* Styles */

/**
 * Renders Expression Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @param sectionContent.lang
 * @param sectionContent.region
 */
const Offerings = ({ sectionContent, lang, region }) => {
  return (
    <Box w="full" p="30px 0">
      {sectionContent && sectionContent.length
        ? sectionContent.map(section => {
            if (section._modelApiKey === 'card_info3_column_group') {
              return (
                <SamskritiOfferingCard
                  key={nanoid(5)}
                  sectionContent={section}
                  region={region}
                  lang={lang}
                />
              );
            } else if (section._modelApiKey === 'section_title') {
              return (
                <Box
                  key={nanoid(5)}
                  maxW={'770px'}
                  mx="auto"
                  fontFamily="FedraSansStd-A-medium"
                  fontSize={{
                    base: '24px',
                    md: '30px',
                  }}
                  lineHeight="1.1"
                  color='#fff'
                  textAlign="center"
                  my={{
                    base: '30px',
                    md: '30px',
                  }}
                >
                  <Box as="h2" mb={1}>
                    {section?.titleText}
                    <Box>{section?.titleSubtext}</Box>
                  </Box>

                  <Box textAlign="center" mb=".1rem">
                    <LazyLoadImageComponent
                      alt=""
                      title=""
                      src={`${config.imgPath}/d/46272/1663580352-divider_light.svg`}
                    />
                  </Box>
                </Box>
              );
            }
            return (
              <SectionUI
                key={nanoid(4)}
                sectionContent={section}
                region={region}
                language={lang}
              />
            );
          })
        : null}
      {/* </Box> */}
    </Box>
  );
};

export default Offerings;
